import type { SVGProps } from "react";

import { cn } from "@/utils/cn";

type IconProps = SVGProps<SVGSVGElement>;

// Figma "icons / system" warning triangle, drawn on a 16px grid. Colored by the text around it.
export const Warning = ({ className, ...props }: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
    className={cn("size-ds-icon-base", className)}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.26373 3.07754C6.44474 2.77913 6.6996 2.53241 7.00373 2.36118C7.30786 2.18995 7.65098 2.1 8 2.1C8.34902 2.1 8.69214 2.18995 8.99627 2.36118C9.3004 2.53241 9.55526 2.77913 9.73627 3.07754L9.73937 3.08264L13.7865 9.839L13.7952 9.85384C13.9725 10.1609 14.0663 10.5091 14.0673 10.8636C14.0683 11.2182 13.9765 11.5669 13.8009 11.875C13.6253 12.183 13.3721 12.4397 13.0665 12.6195C12.7609 12.7994 12.4135 12.896 12.0589 12.8999L12.0471 12.9H3.95288L3.94106 12.8999C3.58649 12.896 3.23913 12.7994 2.93353 12.6195C2.62792 12.4397 2.37473 12.183 2.19913 11.875C2.02354 11.5669 1.93167 11.2182 1.93266 10.8636C1.93366 10.5091 2.02748 10.1609 2.20479 9.85384L2.21353 9.839L6.26373 3.07754ZM3.95288 11.8249C3.78603 11.8231 3.62256 11.7776 3.47875 11.693C3.33493 11.6083 3.21578 11.4875 3.13315 11.3426C3.05052 11.1976 3.00728 11.0335 3.00775 10.8667C3.00822 10.6998 3.05237 10.536 3.13581 10.3915L7.18293 3.63511C7.26811 3.49468 7.38805 3.37858 7.53117 3.298C7.67429 3.21742 7.83576 3.17509 8 3.17509C8.16424 3.17509 8.32571 3.21742 8.46883 3.298C8.61195 3.37858 8.73189 3.49468 8.81707 3.63511L12.8642 10.3915C12.9476 10.536 12.9918 10.6998 12.9922 10.8667C12.9927 11.0335 12.9495 11.1976 12.8669 11.3426C12.7842 11.4875 12.6651 11.6083 12.5213 11.693C12.3774 11.7776 12.214 11.8231 12.0471 11.8249H3.95288Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99964 4.83212C8.31065 4.83212 8.56278 5.08425 8.56278 5.39527V8.00279C8.56278 8.3138 8.31065 8.56593 7.99964 8.56593C7.68862 8.56593 7.4365 8.3138 7.4365 8.00279V5.39527C7.4365 5.08425 7.68862 4.83212 7.99964 4.83212Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.15493 10.3088C7.15493 9.84224 7.53312 9.46405 7.99964 9.46405H8.00418C8.4707 9.46405 8.84889 9.84224 8.84889 10.3088C8.84889 10.7753 8.4707 11.1535 8.00418 11.1535H7.99964C7.53312 11.1535 7.15493 10.7753 7.15493 10.3088Z"
      fill="currentColor"
    />
  </svg>
);
